// extracted by mini-css-extract-plugin
export var modal = "_dp-0";